import React, { useRef, useState } from 'react';
import './Course.css';
import course1 from '../../assets/images/courses/course-1.jpg';
import course2 from '../../assets/images/courses/course-2.jpg';
import course3 from '../../assets/images/courses/course-3.jpg';
import course4 from '../../assets/images/courses/course-4.jpg';
import course5 from '../../assets/images/courses/course-5.jpg';
import course6 from '../../assets/images/courses/course-6.jpg';
import course7 from '../../assets/images/courses/course-7.jpg';
import course8 from '../../assets/images/courses/course-8.jpg';

interface PriceInfoType {
  amount: string;
  unit?: string;
  amountClassName?: string;
  unitClassName?: string;
  originalPriceText?: string;
  originalPriceClassName?: string;
}

interface CourseType {
  id: number;
  title: string;
  description?: string;
  trainerName: string;
  features: string[];
  priceInfo: PriceInfoType;
  additionalPrice?: PriceInfoType;
  backgroundColor: string;
  imageUrl: string;
}

const Course: React.FC = () => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCourseForModal, setSelectedCourseForModal] = useState<CourseType | null>(null);

  const courses: CourseType[] = [
    {
      id: 1,
      title: "徒手健身基礎體能班",
      trainerName: "教練: Christine",
      features: [
        "高強度間歇團體訓練",
        "增強心肺功能",
        "消脂修身同時增強肌力",
      ],
      priceInfo: { amount: "$240", unit: "試堂", originalPriceText: "(原價$280)" },
      backgroundColor: "#f8f8f8",
      imageUrl: course1,
      description: "*無需任何體能基礎，適合所有程度人士參與\n✅每月設不同訓練主題\n✅高強度間歇團體訓練\n✅增強心肺功能\n✅消脂修身同時增強肌力\n🎯目標：\n🔥解鎖引體上升及雙槓撐體並增加下數\n🔥挑戰2個月內達致增肌減脂效果\n\n收費：$2100/8堂(1 Session)\n試堂：原價$280/1堂\n試玩優惠價：$240/1堂🔥\n人數：6-8人\n時間：\n逢星期一、二及四7:00p.m.-8:30p.m.\n逢星期二、三及五12:00p.m.-1:30p.m.\n逢星期五8:30p.m.-10:00p.m."
    },
    {
      id: 2,
      title: "徒手健身進階體能班",
      trainerName: "教練: Ar Chi",
      features: [
        "結合系統化科學訓練理論",
        "詳細拆解健身迷思",
        "消脂修身同時增強肌力"
      ],
      priceInfo: { amount: "$240", unit: "試堂", originalPriceText: "(原價$280)" },
      backgroundColor: "#f8f8f8",
      imageUrl: course2,
      description: "✅高強度間歇團體訓練\n✅結合系統化科學訓練理論\n✅詳細拆解健身迷思\n✅增強心肺功能\n✅消脂修身\n🎯目標：\n🔥掌握運用自身體重調節難易程度訓練各個肌群的方法\n🔥挑戰2個月內達致增肌減脂效果\n\n收費：$2100/8堂(1 Session)\n試堂：原價$280/1堂\n試玩優惠價：$240/1堂🔥\n人數：6-8人\n時間:\n逢星期日10:30a.m.-12:00p.m."
    },
    {
      id: 3,
      title: "兒童健體班",
      trainerName: "教練: Jack Mo",
      features: [
        "增強兒童身體協調",
        "發展大肌肉力量",
        "培養良好紀律和專注度"
      ],
      priceInfo: { amount: "$300", unit: "試堂", originalPriceText: "(原價$350)" },
      backgroundColor: "#f8f8f8",
      imageUrl: course3,
      description: "為培養兒童對運動的興趣，甚或發掘他們的運動潛能，JSW Studio特意開辦兒童健體班，提供一個安全舒適的訓練環境及有趣的課程，鼓勵小朋友培養持續運動的習慣💪🏼\n\n訓練班會利用單槓、雙槓及地板由淺入深教授不同類型的健體鍛鍊和有氧運動，並以各種有趣的團體遊戲形式，訓練兒童的身體協調及體能，並改善自律性和專注力，同時加強學員的身心發展🫶🏻和社交能力👥。\n\n✅增強兒童身體協調\n✅發展大肌肉力量，為日後體育發展打好基礎\n✅提升自信，勇於自我挑戰 \n✅培養良好紀律和專注度\n✅培養團隊合作精神\n\n收費：$2400/8堂（1 Session）\n試堂：原價 $350/1堂\n試玩優惠價：$300/1堂🔥\n年齡：6-10歲\n人數：3-5人\n時間：\n星期三4:30p.m.-6:00p.m.\n星期六10:30a.m.-12:00p.m.\n星期日12:00p.m.-1:30p.m."
    },
    {
      id: 4,
      title: "女子街頭健身技巧班",
      trainerName: "教練: Christine",
      features: [
        "全女子班訓練",
        "混合體能及入門技巧動作",
        "訓練身體協調同時消脂修身"
      ],
      priceInfo: { amount: "$240", unit: "試堂", originalPriceText: "(原價$280)" },
      backgroundColor: "#f8f8f8",
      imageUrl: course4,
      description: "*無需任何體能基礎，適合所有程度女士參與\n\n全港首個由世界排名街頭健身女教練教授的女子班🚺✨ 女教練能以自身經歷帶領更多女學生接觸街頭健身，對女性的需要、困難和挑戰都瞭如指掌🤓\n\n女教練會教導你以最安全的方法去訓練體能，亦會教授入門街頭健身技巧，讓女性都可以體驗街頭健身樂趣！\n\n✅全女子班訓練\n✅混合體能及入門技巧動作\n✅訓練身體協調同時消脂修身\n✅利用徒手訓練增強肌肉力量\n✅安全設備令訓練更易上手\n\n收費：$2100/8堂(1 session)\n試堂：原價$280/1堂\n試玩優惠價：$240/1堂🔥\n人數：4-6人\n時間：逢星期一及四8:30p.m.-9:30p.m."
    },
    {
      id: 5,
      title: "街頭健身基礎技巧班",
      trainerName: "教練: Nicholas",
      features: [
        "挑戰身體協調",
        "靜態動作以及動態技巧訓練",
        "技巧動作包括翻轉力上槓、倒立、人旗"
      ],
      priceInfo: { amount: "$300", unit: "試堂", originalPriceText: "(原價$350)" },
      backgroundColor: "#f8f8f8",
      imageUrl: course5,
      description: "*無需任何體能基礎，適合所有程度人士參與\n\n剛接觸街頭健身但卻無從入手？想挑戰花式動作但欠缺安全設備？\n✅冠軍級導師\n✅靜態動作以及動態技巧訓練\n✅挑戰身體協調\n✅安全設備令訓練更易上手\n🎯課程內容包括：\n🔥暴力上槓\n🔥倒立\n🔥人旗\n🔥Dragon 360\n🔥雙槓花式\n‼️以及更多不同技巧動作‼️\n\n收費: $2400/8堂(1 session)\n試堂：原價$350/1堂\n試玩優惠價：$300/1堂🔥\n人數：6-8人\n時間: \n逢星期二及星期四8:30p.m.-10:00p.m.\n逢星期五7:00p.m.-8:30p.m."
    },
    {
      id: 6,
      title: "街頭健身進階技巧班",
      trainerName: "教練: Jay",
      features: [
        "動態花式技巧",
        "靜態力量動作",
        "身體協調訓練"
      ],
      priceInfo: { amount: "$300", unit: "試堂", originalPriceText: "(原價$350)" },
      backgroundColor: "#f8f8f8",
      imageUrl: course6,
      description: "*體能要求: 引體上升5 雙槓撐體5 跳箱5\n\n適合想把街頭健身技巧更上一層樓甚至乎參加比賽挑戰的你。\n✅冠軍級導師\n✅動態花式技巧\n✅靜態力量動作\n✅身體協調訓練\n🎯課程內容包括：\n🔥暴力上槓轉體360\n🔥轉體360\n🔥俄式挺身\n🔥前水平及後水平\n\n收費：$2400/8堂(1 Session)\n試堂：原價$350/1堂\n試玩優惠價：$300/1堂🔥\n人數：6-8人\n時間：逢星期六6:30p.m.-8:00p.m."
    },
    {
      id: 7,
      title: "1對1 /2街頭健身訓練班",
      trainerName: "",
      features: [
        "教練度身訂造訓練內容",
        "彈性上課時間",
        "技巧訓練、增肌減脂"
      ],
      priceInfo: { amount: "$600", unit: " 1人試堂", originalPriceText: "" },
      additionalPrice: { amount: "$850", unit: " 2人試堂", originalPriceText: "" },
      backgroundColor: "#f8f8f8",
      imageUrl: course7,
      description: "教練度身訂造訓練內容，令你循序漸進達成目標。針對性訓練令你訓練事半功倍，更快達成目標。適用於希望專注訓練不同技能，增強力量甚至達致美好身材等學員。\n🎯目標：\n🔥增肌減脂改善身形及增強肌力\n🔥打好街頭健身花式技巧基礎\n🔥街頭健身技巧專項訓練\n🔥街頭健身比賽訓練\n\n試玩收費：\n$600/1 人 \n$850/2 人\n\n1對1正式課堂收費：\n$3500/5堂 (平均$700一堂)\n$6500/10堂 (平均$650一堂)\n\n1對2正式課堂收費：\n$4250/5堂 (平均$850一堂)\n$8000/10堂(平均$800一堂)\n\n地點：JSW STUDIO\n時間：1小時 (上課時間與教練約定)\n人數：1-2人"
    },
    {
      id: 8,
      title: "親子私人訓練班 (1對2/1對3)",
      trainerName: "教練: Jack Mo",
      features: [
        "增進親子關係",
        "增強家長及小朋友的體能健康",
        "建立家庭健康生活習慣"
      ],
      priceInfo: { amount: "$600", unit: " 2人試堂", originalPriceText: "" },
      additionalPrice: { amount: "$850", unit: " 3人試堂", originalPriceText: "" },
      backgroundColor: "#f8f8f8",
      imageUrl: course8,
      description: "教練度身訂造訓練內容，利用單槓、雙槓及地板由淺入深教授不同類型的健體鍛鍊和有氧運動，並以各種有趣的遊戲形式，讓家長和小朋友可以一同訓練同時增進親子關係，更可以訓練兒童的身體協調及體能，改善自律性和專注力，同時加強學員的身心發展🫶🏻，鼓勵家長和小朋友培養持續運動的習慣💪🏼\n\n✅增進親子關係\n✅同時增強家長及小朋友的體能健康\n✅建立家庭健康生活習慣\n✅增強兒童身體協調\n✅培養良好紀律和專注度\n\n試堂：原價 $700/2人；$900/3人\n試堂優惠價：$600/2人；$850/3人🔥\n年齡：3歲或以上\n地點：JSW STUDIO\n時間：1小時 (上課時間與教練約定)\n人數：2-3人\n\n正式課堂收費：\n$6000/10堂 （1對2）\n$8500/10堂（1對3）"
    }
  ];

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const { clientWidth } = scrollContainerRef.current;
      const scrollAmount = clientWidth * 0.8;
      scrollContainerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const openModal = (course: CourseType) => {
    // Convert newlines to <br> tags for proper HTML display
    if (course.description) {
      course.description = course.description.replace(/\n/g, '<br />');
    }
    setSelectedCourseForModal(course);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCourseForModal(null);
  };

  return (
    <section id="courses" className="course-section section">
      <div className="section-container">
        <h2 className="section-title">JSW 課程</h2>
        
        <div className="carousel-container">
          {showLeftArrow && (
            <button className="scroll-arrow left" onClick={() => scroll('left')}>
              &#10094;
            </button>
          )}
          
          <div 
            className="courses-carousel" 
            ref={scrollContainerRef}
            onScroll={handleScroll}
          >
            {courses.map(course => (
              <div 
                key={course.id} 
                className="course-card"
                style={{ backgroundColor: course.backgroundColor }}
              >
                <div className="course-image">
                  <img 
                    src={course.imageUrl} 
                    alt={course.title} 
                    className="course-img" 
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.onerror = null;
                      target.src = course1;
                    }}
                  />
                </div>
                
                <div className="course-content">
                  <h3 className="course-title">{course.title}</h3>
                   <div className="course-trainer-name">{course.trainerName}</div>
                  
                  <ul className="course-features">
                    {course.features.map((feature, index) => (
                      <li key={index}>
                        <span className="star-icon">★</span> {feature}
                      </li>
                    ))}
                  </ul>
                  
                  <div className="course-price-container">
                    <div className="price">
                      <span className={course.priceInfo.amountClassName}>{course.priceInfo.amount}</span>
                      {course.priceInfo.unit && <span className={course.priceInfo.unitClassName}> {course.priceInfo.unit}</span>}
                      {course.priceInfo.originalPriceText && (
                        <span className={`original-price ${course.priceInfo.originalPriceClassName || ''}`}>
                          {' '}{course.priceInfo.originalPriceText}
                        </span>
                      )}
                    </div>
                    {course.additionalPrice && (
                      <div className="additional-price">
                        <span>{course.additionalPrice.amount}</span>
                        {course.additionalPrice.unit && <span> {course.additionalPrice.unit}</span>}
                        {course.additionalPrice.originalPriceText && (
                          <span className="original-price"> {course.additionalPrice.originalPriceText}</span>
                        )}
                      </div>
                    )}
                  </div>
                  <button className="course-details-button" onClick={() => openModal(course)}>
                    課堂詳情
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          {showRightArrow && (
            <button className="scroll-arrow right" onClick={() => scroll('right')}>
              &#10095;
            </button>
          )}
        </div>
      </div>

      {isModalOpen && selectedCourseForModal && (
        <div className="course-modal-overlay" onClick={closeModal}>
          <div className="course-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="course-modal-close-button" onClick={closeModal}>&times;</button>
            <h2 className="course-modal-title">{selectedCourseForModal.title}</h2>
            {selectedCourseForModal.trainerName && <p className="course-modal-trainer">{selectedCourseForModal.trainerName}</p>}
            <img 
              src={selectedCourseForModal.imageUrl} 
              alt={selectedCourseForModal.title} 
              className="course-modal-image"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.onerror = null;
                target.src = course1;
              }}
            />
            <div className="course-modal-description" dangerouslySetInnerHTML={{ __html: selectedCourseForModal.description || '詳細課程內容即將更新。' }} />
          </div>
        </div>
      )}
    </section>
  );
};

export default Course;
